import { JobOptionSvc } from 'domains/jobconfigDomain';
import { useMemo } from 'react';

interface Iprops {
  svcs?: JobOptionSvc[];
}

export const useSvcHasImg = (props: Iprops) => {
  // const { svcs } = props;
  // const jobImgList = useSvcImgList();

  const hasImg = useMemo(() => {
    // const hasImgJob = jobImgList.find((item) => {
    //   return Boolean(
    //     svcs?.find((job) => {
    //       return (
    //         job.revxId === item.revxId && job.revxTypeId === item.revxTypeId
    //       );
    //     })
    //   );
    // });
    // return Boolean(hasImgJob);
    return true;
  }, []);

  return hasImg;
};
